import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import BlogCard from '../../components/blog/BlogCard';
import blogsData from '../../data/blogs.json';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const LatestBlogs = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    const sortedBlogs = blogsData.sort((a, b) => new Date(b.date) - new Date(a.date));
    setBlogs(sortedBlogs.slice(0, 3));
  }, []);

  const sliderSettings = {
    dots: true,
    infinite: false,
    speed: 500,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 1024,
        settings: 'unslick',
      },
    ],
  };

  return (
    <section className="latest-blogs py-12 px-4 md:px-8 lg:px-16 bg-white">
      <h2 className="text-2xl text-center font-bold text-gray-800 mb-8">Latest Blogs</h2>

      {/* Mobile Slider */}
      <div className="block md:hidden">
        <Slider {...sliderSettings}>
          {blogs.map((blog) => (
            <div key={blog.id} className="px-2">
              <BlogCard blog={blog} />
            </div>
          ))}
        </Slider>
      </div>

      {/* Desktop Grid */}
      <div className="hidden md:grid grid-cols-2 lg:grid-cols-3 gap-4">
        {blogs.map((blog) => (
          <BlogCard key={blog.id} blog={blog} />
        ))}
      </div>

      {/* More Blogs Button */}
      <div className="flex justify-center mt-8">
        <a
          href="/blogs"
          className="px-6 py-2 border border-black text-sm font-medium hover:bg-black hover:text-white transition rounded"
        >
          More Blogs
        </a>
      </div>
    </section>
  );
};

export default LatestBlogs;
